module.exports = __webpack_public_path__ + "static/assets/3d159711a8ea408853382f571a3bbfae.svg";